import * as api from "../API/index";

export const getAttendanceLock = async () => {
  try {
    const res = await api.get_attendance_lock();
    return res.data;
  } catch (error) {
    return error?.response?.data || error;
  }
};

export const updateAttendanceLock = async (bodyData) => {
  try {
    const res = await api.update_attendance_lock(bodyData);
    return res.data;
  } catch (error) {
    return error?.response?.data || error;
  }
};
